import React from "react";
import ScrollAnimation from "../../hooks/ScrollAnimation";
import LanguageLink from "../routing/LanguageLink";
export default function HelpSection() {
    return (
        <section className="py-16 bg-blue-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <ScrollAnimation direction="up" delay={0.1}>
                    <div className="text-center">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            Need Help with Immigration Forms?
                        </h2>
                        <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
                            Our experienced immigration attorneys can help you navigate the
                            complex immigration process and ensure your forms are completed
                            correctly.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <LanguageLink to={"/contact"} className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                                Schedule Consultation
                            </LanguageLink>
                            <LanguageLink to={"/contact"} className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold border border-blue-600 hover:bg-blue-50 transition-colors">
                                Contact Us
                            </LanguageLink>
                        </div>
                    </div>
                </ScrollAnimation>
            </div>
        </section>
    );
}
